/*
 * Copyright (c) 2024. . Yantodev - All Rights Reserved.
 * @Author  :  yantodev
 * mailto : ekocahyanto007@gmail.com
 * link : https://yantodev.my.id/
 */

export const REQUEST_LOGIN = 'REQUEST_LOGIN';
export const REQUEST_LOGIN_SUCCESS = 'REQUEST_LOGIN_SUCCESS';
export const REQUEST_LOGIN_FAILURE = 'REQUEST_LOGIN_FAILURE';

export const REQUEST_SCOPE = 'REQUEST_SCOPE';
export const REQUEST_SCOPE_SUCCESS = 'REQUEST_SCOPE_SUCCESS';
export const REQUEST_SCOPE_FAILURE = 'REQUEST_SCOPE_FAILURE';
